module.exports = __webpack_public_path__ + "static/img/107.d7d3e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/107.png
// module id = RkdC
// module chunks = 0